/* eslint-disable  max-classes-per-file */
class SearchFunctions {
  subCalculator(first, types) {
    this.sub = first;
    if (Array.isArray(types)) {
      let line = ' / ';
      for (let i = 0; i < types.length; i += 1) {
        line += types[i].name + (i !== types.length - 1 ? ', ' : '');
      }
      this.sub += line;
      return;
    }
    this.sub += ` / ${types.name}`;
  }
}

export class Place extends SearchFunctions {
  constructor(item, cfg, name, type = 'Places') {
    super();
    this.name = item.name;
    this.subCalculator(type, item.type);
    const url = {
      name,
      params: {
        region: cfg.region,
        id: item.type.id,
        object: item.id,
      },
    };
    this.use = {
      nuxt: true,
      url: window.location.hostname.includes('cabinet') ? `${cfg.service}/${cfg.lang}/${cfg.region}/objects/${url.params.id}/${url.params.object}` : (typeof cfg.pathFunc === 'function' ? cfg.pathFunc(url) : url),
      // url: `${cfg.service}/${cfg.lang}/${cfg.region}/objects/${url.params.id}/${url.params.object}`,
    };
  }
}

export class PlaceOnService extends SearchFunctions {
  constructor(item, cfg) {
    super();
    this.name = item.name;
    this.subCalculator('Заведения', item.type);
    this.use = {
      nuxt: false,
      url: `${cfg.service}/${cfg.lang}/${cfg.region}/objects/${item.type.id}/${item.id}`,
    };
  }
}

export class Event extends SearchFunctions {
  constructor(item, cfg, name, type = 'Afisha') {
    super();
    this.name = item.name;
    this.subCalculator(type, item.types);
    const url = {
      name,
      params: {
        region: cfg.region,
        id: item.types[0].slug,
        event: item.id,
      },
    };
    this.use = {
      nuxt: true,
      url: window.location.hostname.includes('cabinet') ? `${cfg.service}/${cfg.lang}/${cfg.region}/events/${item.types[0].slug}/${item.id}` : (typeof cfg.pathFunc === 'function' ? cfg.pathFunc(url) : url),
      // url: `${cfg.service}/${cfg.lang}/${cfg.region}/events/${item.types[0].slug}/${item.id}`,
    };
  }
}

export class EventOnService extends SearchFunctions {
  constructor(item, cfg, type = 'Afisha') {
    super();
    this.name = item.name;
    this.subCalculator(type, item.types);
    this.use = {
      nuxt: false,
      url: `${cfg.service}/${cfg.lang}/${cfg.region}/events/${item.types[0].slug}/${item.id}`,
    };
  }
}

export class Video extends SearchFunctions {
  constructor(item, cfg, name, type = 'Afisha') {
    super();
    this.name = item.title;
    this.subCalculator(type, { name: 'Онлайн-просмотр'});
    const url = {
      name,
      params: {
        region: cfg.region,
        id: item.id,
      },
    };
    this.use = {
      nuxt: true,
      url: typeof cfg.pathFunc === 'function' ? cfg.pathFunc(url) : url,
    };
  }
}

export class VideoOnService extends SearchFunctions {
  constructor(item, cfg, type = 'Afisha') {
    super();
    this.name = item.title;
    this.subCalculator(type, { name: 'Онлайн-просмотр'});
    this.use = {
      nuxt: false,
      url: `${cfg.service}/${cfg.lang}/${cfg.region}/videos/${item.id}`,
    };
  }
}

export class Name extends SearchFunctions {
  constructor(item, cfg, name, type = 'Afisha') {
    super();
    this.name = item.title;
    this.subCalculator(type, { name: 'Имена'});
    const url = {
      name,
      params: {
        id: item.id,
      },
    };
    this.use = {
      nuxt: true,
      url: typeof cfg.pathFunc === 'function' ? cfg.pathFunc(url) : url,
    };
  }
}

export class NameOnService extends SearchFunctions {
  constructor(item, cfg, type = 'Afisha') {
    super();
    this.name = item.title;
    this.subCalculator(type, { name: 'Туры'});
    this.use = {
      nuxt: false,
      url: `${cfg.service}/${cfg.lang}/other/tours/${item.id}`,
    };
  }
}

export class Post extends SearchFunctions {
  constructor(item, cfg, name) {
    super();
    this.name = item.title;
    this.subCalculator('Журнал', item.category);
    const url = {
      name,
      params: {
        region: cfg.region,
        id: item.category.id,
        post: item.id,
      },
    };
    this.use = {
      nuxt: true,
      url: typeof cfg.pathFunc === 'function' ? cfg.pathFunc(url) : url,
    };
  }
}

export class PostOnService extends SearchFunctions {
  constructor(item, cfg, type = 'Journal') {
    super();
    this.name = item.title;
    this.subCalculator(type, item.category);
    this.use = {
      nuxt: false,
      url: `${cfg.service}/${cfg.lang}/${cfg.region}/journal/${item.category.id}/${item.id}`,
    };
  }
}
/* eslint-enable  max-classes-per-file */
